//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import { objectsConstants } from '../../constants/objects.constants';
import { isAdmin, isAdminBio, isSudo } from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { userService } from '../../services/user.service';
import FormInput from '../../components/Inputs/FormInput';
import DatePickerInput from '../../components/Inputs/DatePickerInput';

type Props = {
  onChangeText: any,
  entity: any,
  onChangeValue: any,
};

export default class PedidoDevolucaoCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    const user = userService.getCurrentUser();

    return (
      <React.Fragment>
        {(isSudo() || isAdminBio()) && (
          <FormGroup className="col-12 col-md-3">
            <FormSelectInput
              name="cliente"
              id="cliente"
              label="Cliente"
              placeholder="Selecione o cliente"
              valueKey="codigoCliente"
              labelKey="label"
              required={true}
              returnFullObject={true}
              service={clienteService.findAll}
              onChange={this.props.onChangeDate}
              value={entity.cliente}
            />
          </FormGroup>
        )}
        <FormGroup className="col-12 col-md-2">
          <SelectInput
            name="status"
            id="status"
            label="Status"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={false}
            options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
            onChange={(name, value) => {
              this.props.onChangeValue(value, name);
            }}
            value={entity.status}
          />
        </FormGroup>
        <FormGroup className="col-12 col-md-2">
          <SelectInput
            name="statusColeta"
            id="statusColeta"
            label="Status Coleta"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={false}
            options={objectsConstants.STATUS_COLETA_DEVOLUCAO}
            onChange={(name, value) => {
              this.props.onChangeValue(value, name);
            }}
            value={entity.statusColeta}
          />
        </FormGroup>

        <FormGroup className="col-12 col-xl-2">
          <DatePickerInput
            name="dataColeta"
            id="dataColeta"
            label="Data Coleta"
            placeholder="Data Coleta"
            onChange={this.props.onChangeDate}
            value={entity.dataColeta}
            noSize
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <FormInput
            label="Número do Pedido"
            placeholder={'Número do pedido'}
            id={'numeroPedido'}
            name="numeroPedido"
            noSize
            onChange={this.props.onChangeDate}
            type={'text'}
            value={entity.numeroPedido}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <DatePickerInput
            name="createdAt"
            id={'createdAt'}
            label="Data criação"
            placeholder="Data criação"
            onChange={this.props.onChangeDate}
            value={entity.createdAt}
            noSize
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            name="urgente"
            id="urgente"
            label="É Urgente?"
            placeholder="Selecione"
            valueKey="value"
            labelKey="label"
            returnFullObject={true}
            options={objectsConstants.SIM_NAO}
            onChange={(name, selected) => {
              this.props.onChangeValue(selected.value, name);
            }}
            value={
              objectsConstants.SIM_NAO.find(
                (opt) => opt.value === entity.urgente,
              ) || null
            }
          />
        </FormGroup>

        {(isAdmin() || isAdminBio()) && (
          <FormGroup className="col-12 col-xl-3">
            <FormSelectInput
              name="pontoAtendimentoId"
              id="pontoAtendimentoId"
              label="Ponto de Atendimento"
              placeholder="Selecione o PA"
              valueKey="id"
              labelKey="nome"
              required={true}
              returnFullObject={false}
              parent={isSudo() ? entity.cliente : user.cliente}
              service={
                isSudo() || isAdminBio()
                  ? pontoAtendimentoService.findAll
                  : pontoAtendimentoService.findAllByCliente
              }
              onChange={this.props.onChangeDate}
              value={entity.pontoAtendimentoId}
            />
          </FormGroup>
        )}

        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Responsável"
            placeholder={'Responsável'}
            id={'responsavel'}
            name="responsavel"
            onChange={this.props.onChangeDate}
            type={'text'}
            value={entity.responsavel}
            noSize
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Criado por"
            placeholder={'Criado por'}
            id={'criadoPor'}
            name="criadoPor"
            onChange={this.props.onChangeDate}
            type={'text'}
            value={entity.criadoPor}
            noSize
          />
        </FormGroup>

        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Aprovado por"
            placeholder={'Aprovado por'}
            id={'aprovadoPor'}
            name="aprovadoPor"
            onChange={this.props.onChangeDate}
            type={'text'}
            value={entity.aprovadoPor}
            noSize
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
